import { MapPin, Phone, Smartphone, Clock } from 'lucide-react';
import logoSvg from '@/assets/logo.svg';

const PHONE_LANDLINE = '011 971497';
const PHONE_MOBILE = '345 9051239';
const ADDRESS = 'Via Maestri Cordai, 11/a, 10022 Carmagnola (TO)';
const GOOGLE_MAPS_URL = 'https://www.google.com/maps/dir/?api=1&destination=Via+Maestri+Cordai+11a+Carmagnola+TO+Italy';

const Footer = () => {
  return (
    <footer id="contatti" className="bg-card border-t border-border py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src={logoSvg} alt="Pizzeria La Torre" className="h-12 w-auto" />
              <span className="font-display text-2xl font-bold text-foreground">
                Pizzeria La Torre
              </span>
            </div>
            <p className="text-muted-foreground text-sm">
              Dall'amore per il nostro lavoro nascono sapori autentici e un impasto che racconta la tradizione di famiglia.
            </p>
          </div>

          {/* Contact */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold text-foreground mb-4">
              Contatti
            </h4>
            <div className="space-y-3">
              <a 
                href={`tel:${PHONE_LANDLINE.replace(/\s/g, '')}`} 
                className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors"
              >
                <Phone className="h-5 w-5 flex-shrink-0" />
                <span className="whitespace-nowrap">Fisso: {PHONE_LANDLINE}</span>
              </a>
              <a 
                href={`tel:${PHONE_MOBILE.replace(/\s/g, '')}`} 
                className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors"
              >
                <Smartphone className="h-5 w-5 flex-shrink-0" />
                <span className="whitespace-nowrap">Cell: {PHONE_MOBILE}</span>
              </a>
              <a 
                href={GOOGLE_MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors"
              >
                <MapPin className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <span>{ADDRESS}</span>
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold text-foreground mb-4">
              Orari
            </h4>
            <div className="flex items-start gap-3 text-muted-foreground">
              <Clock className="h-5 w-5 flex-shrink-0 mt-0.5" />
              <div>
                <p>Tutti i giorni <span className="text-destructive font-medium">tranne il martedì</span></p>
                <p className="text-foreground font-medium">17:30 – 22:00</p>
                <p className="text-sm mt-1">Martedì: <span className="text-destructive font-medium">Chiuso</span></p>
              </div>
            </div>
          </div>
        </div>

        {/* Google Maps Embed - 3:1 aspect ratio */}
        <div className="mt-12 rounded-xl overflow-hidden border border-border">
          <div className="relative w-full" style={{ paddingBottom: '33.33%' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2826.5!2d7.717!3d44.848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47886d1b8e8e8e8e%3A0x0!2sPiazza%20Maestri%20Cordai%2011%2Fa%2C%20Carmagnola!5e0!3m2!1sit!2sit!4v1234567890"
              className="absolute inset-0 w-full h-full grayscale hover:grayscale-0 transition-all duration-500"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Posizione Pizzeria La Torre"
            />
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Pizzeria La Torre. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;